export const isActiveLoyaltyUser = status => {
  return !['SUSPENDED', 'CANCELLED'].includes(status);
};
